import { api } from "@//api";

export const pulseBarrier = async (barrierId: string) => {
  const { body } = await api.post(`/barriers/${barrierId}/open/`);
  return body;
};
